(function () {
    "use strict";
    angular
        .module('blocks.modal')
        .directive('obtModalPopup', obtModalPopup)
        .directive('obtModalPopupChoice', obtModalPopupChoice);

    function obtModalPopup() {
        return {
            restrict : 'E',
            require: '?^obtModalPopups', /*optional*/
            scope : {
                name : '=?',
                title: '@?',
                templateUrl:'@',
                templateController: '@',
                openModalPromise: '=?',
                modalModel : '=?'
            },
            controller: ctrlFn ,
            link : linkFn
        };
    }

    function obtModalPopupChoice() {
        return {
            restrict : 'E',
            require: '^obtModalPopup', /*required*/
            scope : {
                templateConditionName:'@?',
                templateConditionValue:'@?',
                templateConditionFn:'&?', // it have the hightest priority
                templateUrl:'@',
                templateController: '@?'
            },
            link : linkChoiceFn
        };
    }

    //---------------------------------------------------------------------
    //controller and link for modal

    /*@ngInject*/
    function ctrlFn ($scope, logger, obtModalService) {

        var modalChoices = [];

        $scope.name = {
            open : openModal
        };

        $scope.openModalPromise = openModal;

        this.addModalChoice = addModalChoice;

        function addModalChoice(choice){
            modalChoices.push(choice);
        }

        function openModal(model, success, fail){
            var settings = getModalSettings(model, success, fail);
            return obtModalService.openModal(settings).result.then(modalClosed);
        }

        function modalClosed(data){
            if (data) {
                if (data.error === 0) {
                    logger.success( data.message);
                }
                else if (data.error === 2) {
                    logger.error(data.message, data);
                }
                else {
                    logger.error("error raised during process");
                }
            }
        }

        function getModalSettings(model, success, fail){
            // set default value
            var templateUrl = $scope.templateUrl;
            var templateController = $scope.templateController;

            //check if a choice is valid
            if (modalChoices && model) {
                var firstMatchingChoice = modalChoices.filter(function(item){
                    return item && item.templateConditionName != null ? String(model[item.templateConditionName]) == item.templateConditionValue : false;
                }).shift();

                console.log(firstMatchingChoice);

                if(firstMatchingChoice){
                    templateUrl = firstMatchingChoice.templateUrl ? firstMatchingChoice.templateUrl : templateUrl;
                    templateController = firstMatchingChoice.templateController ? firstMatchingChoice.templateController : templateController;
                }
            }

            var settings = {
                templateUrl:templateUrl,
                controller:templateController
            };

            $scope.usedModalModel = ! angular.isUndefined(model) ? model : $scope.modalModel;
            settings.resolve = settings.resolve ? settings.resolve : {};
            settings.resolve.modalModel = getSelectedModalModel;

            settings.callbackSuccess = success || callbackSuccess;
            settings.callbackFailed = fail || success || callbackFailed;
            return settings;
        }

        function getSelectedModalModel(){
            return $scope.usedModalModel;
        }

        function callbackSuccess (selectedItem) {
            $scope.selected = selectedItem;
        }

        function callbackFailed () {
        }
    }

    function linkFn(scope, element, attributes, modalsController){
        if (modalsController) {
            modalsController.addModalOption({
                title: attributes.title,
                openModalPromise: scope.openModalPromise
            });
        }
    }

    //----------------------------------------------------------------------
    //controller and link for modal choice

    function linkChoiceFn(scope, element, attributes, modalController){
        if (modalController) {
            modalController.addModalChoice({
                templateConditionName: scope.templateConditionName,
                templateConditionValue: scope.templateConditionValue,
                templateUrl: scope.templateUrl,
                templateController : scope.templateController
            });
        }
    }
})();


/*****************
 ** WEBPACK FOOTER
 ** ./app/blocks/modal/obt-modal.directive.js
 ** module id = 87
 ** module chunks = 0
 **/